import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCakeCandles, faClock } from '@fortawesome/free-solid-svg-icons';
import '../css/CardNotifications.css';

const CardNotifications = ({ cumpleaños = [], tardanzas = [] }) => {
    const hoy = new Date().toISOString().split('T')[0];

    const agruparPorFecha = (items) => {
        const agrupados = {};
        items.forEach(item => {
            const fecha = item.date || hoy;
            if (!agrupados[fecha]) agrupados[fecha] = [];
            agrupados[fecha].push(item);
        });
        return agrupados;
    };

    const notificaciones = [
        ...cumpleaños.map(persona => ({
            tipo: 'cumple',
            nombre: `${persona.person.name} ${persona.person.lastname}`,
            fecha: persona.person.date_of_birth,
        })),
        ...tardanzas.map(persona => ({
            tipo: 'tarde',
            nombre: `${persona.name} ${persona.lastname}`,
            fecha: persona.date,
        })),
    ];

    const agrupados = agruparPorFecha(notificaciones);

    return (
        <div className="card-notificaciones">
            <div className="header">
                <h3 className='metrics-title'>Notificaciones</h3>
            </div>
            {Object.entries(agrupados).map(([fecha, eventos]) => (
                <div key={fecha}>
                    <h4 className="fecha">{fecha === hoy ? 'HOY' : fecha}</h4>
                    {eventos.map((ev, i) => (
                        <div className="item-notificacion" key={i}>
                            <FontAwesomeIcon icon={ev.tipo === 'cumple' ? faCakeCandles : faClock} className="icono" />
                            <span>{ev.tipo === 'cumple'
                                ? `${ev.nombre}, está cumpliendo años el dia ${ev.fecha}🎉`
                                : `${ev.nombre} llegó tarde al trabajo ⏰`
                            }</span>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export default CardNotifications;